export function Sync(): JSX.Element {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.9987 3.33301V0.833008L6.66536 4.16634L9.9987 7.49967V4.99967C12.757 4.99967 14.9987 7.24134 14.9987 9.99967C14.9987 10.8413 14.7904 11.6413 14.4154 12.333L15.632 13.5497C16.282 12.5247 16.6654 11.308 16.6654 9.99967C16.6654 6.31634 13.682 3.33301 9.9987 3.33301ZM9.9987 14.9997C7.24036 14.9997 4.9987 12.758 4.9987 9.99967C4.9987 9.15801 5.20703 8.35801 5.58203 7.66634L4.36536 6.44967C3.71536 7.47467 3.33203 8.69134 3.33203 9.99967C3.33203 13.683 6.31536 16.6663 9.9987 16.6663V19.1663L13.332 15.833L9.9987 12.4997V14.9997Z"
        fill="currentColor"
      />
    </svg>
  );
}
